"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));
var _styles = require("@material-ui/core/styles");
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _excluded = ["isOpen", "toggle", "autoHideDuration", "resumeHideDuration", "action", "message"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledSnackbarContent = (0, _styles.withStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    root: function root(_ref2) {
      var backgroundColor = _ref2.backgroundColor;
      return {
        borderLeft: "6px solid ".concat(backgroundColor || palette.primary.main),
        backgroundColor: 'var(--color-bg-card)',
        borderRadius: 0,
        minWidth: 'auto'
      };
    },
    message: {
      color: palette.text.primary,
      fontWeight: 500,
      minWidth: 170
    },
    action: {
      marginLeft: 0
    }
  };
})(_SnackbarContent["default"]);
var WithHiddenAction = function WithHiddenAction(_ref3) {
  var children = _ref3.children,
    hiddenAction = _ref3.hiddenAction,
    onToggle = _ref3.onToggle;
  var rootRef = (0, _react.useRef)();
  var actionRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: rootRef,
    className: "whitespace-no-wrap ",
    style: {
      transition: 'width 100ms cubic-bezier(0.4, 0, 0.2, 1)'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-block",
    ref: actionRef
  }, children), hiddenAction && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    size: "small",
    className: "!ml-2",
    onClick: onToggle
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)));
};
var _default = exports["default"] = function _default(_ref4) {
  var isOpen = _ref4.isOpen,
    toggle = _ref4.toggle,
    autoHideDuration = _ref4.autoHideDuration,
    resumeHideDuration = _ref4.resumeHideDuration,
    action = _ref4.action,
    message = _ref4.message,
    props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);
  var rootRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hiddenAction = _useState2[0],
    showHiddenAction = _useState2[1];
  var handleClose = function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    toggle(false);
  };
  (0, _react.useEffect)(function () {
    showHiddenAction(false);
    if (isOpen && rootRef.current) {
      var mouseEnterEvent;
      var mouseLeaveEvent;
      rootRef.current.addEventListener('mouseenter', mouseEnterEvent = function mouseEnterEvent() {
        showHiddenAction(true);
      });
      rootRef.current.addEventListener('mouseleave', mouseLeaveEvent = function mouseLeaveEvent() {
        showHiddenAction(false);
      });
      return function () {
        if (rootRef.current) {
          rootRef.current.removeEventListener('mouseenter', mouseEnterEvent);
          rootRef.current.removeEventListener('mouseleave', mouseLeaveEvent);
        }
      };
    }
  }, [isOpen]);
  var newAction = action;
  if (autoHideDuration) {
    newAction = /*#__PURE__*/_react["default"].createElement(WithHiddenAction, {
      hiddenAction: hiddenAction,
      onToggle: toggle
    }, action);
  }
  return /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
    ref: rootRef,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    open: isOpen,
    autoHideDuration: autoHideDuration,
    resumeHideDuration: resumeHideDuration,
    onClose: handleClose
  }, /*#__PURE__*/_react["default"].createElement(StyledSnackbarContent, (0, _extends2["default"])({}, props, {
    action: newAction || /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
      size: 30
    }),
    message: message,
    elevation: 3
  })));
};
//# sourceMappingURL=index.js.map